import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useProgressInfoTitle } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/hooks/useProgressInfoTitle'
import {
  AssignNumberStepsProvider,
  useAssignNumberStepsContext,
} from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/context/useAssignNumberStepsContext'
import { type AssignNumberRoutesSteps } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/store/assignNumberStore'

const AssignNumberLayoutContent = observer(() => {
  const { allStepsLength, decreaseStep, setCurrentStep, getSettingsStep, redirectToNumbers } =
    useAssignNumberStepsContext()
  const settingsStep = useGetStep<AssignNumberRoutesSteps>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep, setCurrentStep])

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='Assign numbers'
      settingsStep={settingsStep}
      closeSetting={redirectToNumbers}
      decreaseStep={decreaseStep}
    />
  )
})

export const AssignNumberStepsLayout = () => {
  return (
    <AssignNumberStepsProvider>
      <AssignNumberLayoutContent />
    </AssignNumberStepsProvider>
  )
}
